var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-my-security-change_email"},[_c('div',{staticClass:"xt-change_phone-form"},[_c('xt-verify-form',_vm._b({on:{"sendSms":_vm.onSendSms,"submit":_vm.onSubmit}},'xt-verify-form',_vm.bind,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }